import { format as urlFormat } from 'url';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import querySearch from 'search-query-parser';
import ENV from '../env';

export const format = ({ query = {}, ...options }) =>
  urlFormat({ ...options, query: omitBy(query, isNil) });

export { default, parse } from 'url';

export const parseSearch = (search, options = {}) => {
  const terms = querySearch.parse(search, options);
  if (typeof terms === 'string') {
    return {
      text: terms,
      offsets: [{ text: terms, offsetStart: 0, offsetEnd: search.length }]
    };
  } else {
    const { exclude, offsets, ...others } = terms;
    const entries = Object.entries(others);
    return entries.length
      ? {
          ...Object.assign(
            ...entries.map(([k, v]) => ({
              [k]: Array.isArray(v) ? v.join(',') : v
            }))
          ),
          exclude,
          offsets
        }
      : terms;
  }
};

const isExcluded = (k, v, excluded = {}) =>
  excluded[k] && excluded[k].indexOf(v) !== -1;

const createToken = (keyword, value, exclude = false) =>
  keyword === 'text'
    ? { text: value, exclude }
    : typeof value === 'string'
      ? { keyword, value, exclude }
      : value instanceof Array
        ? { keyword, value: value.join(','), exclude }
        : { keyword, value: `${value.from}-${value.to}`, exclude };

const tokenizeTerms = (terms = {}, exclude = false) =>
  Object.keys(terms).map(k => createToken(k, terms[k], exclude));

export const formatSearch = (terms = {}, useOffsets = true) => {
  const { offsets, exclude: excluded, ...props } = terms;
  const tokens =
    offsets && useOffsets
      ? offsets
      : [...tokenizeTerms(props), ...tokenizeTerms(excluded, true)];
  return (
    tokens
      // eslint-disable-next-line no-unused-vars, (offsetStart)
      .map(({ exclude, text = '', value, keyword, offsetStart }) => {
        const v =
          keyword && value
            ? `${keyword}:${
                value.includes(' ') ? JSON.stringify(value) : value
              }`
            : text.trim();
        const x = keyword
          ? exclude || isExcluded(keyword, value, excluded)
          : false;
        return `${x ? '-' : ''}${v}`;
      })
      .join(' ')
      .trim()
  );
};

export const getFileUrl = (teamName, fileName = '') => {
  return `${ENV.PUSHBOT_API_PATH}/teams/${teamName}/files/${fileName}/download`;
};



// WEBPACK FOOTER //
// ./js/util/url.js